module.exports = __webpack_public_path__ + "img/HP-sec06-image-01-Mexico.5adcac25.svg";